'use strict';

// Babel6 does not hack the default behaviour of ES Modules anymore, so we should export

var Collapse = require('./Collapse').default;

module.exports = Collapse;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/remi/Documents/metabase/metabase-0.28.1/node_modules/react-collapse/lib/index.js
// module id = 2178
// module chunks = 7